import { Injectable } from '@angular/core';
import { RequestBodyService } from '../../../services';
import { SavedSearches } from '../../../services/saved-searches.service';
import { CompanyService } from '../../../../results/companies/services';
import { ContactsService } from '../../../../results/contacts/services/contacts.service';
import { SearchService } from '../../../../results/search/services/search.service';
import { Router } from '@angular/router';
import { CommonUtilService } from '../../../services/CommonUtil.service';
import { UniversalSearchModelType } from '../../../../core/models/universal-search.model';

@Injectable({
  providedIn: 'root'
})
export class ReportingDashboardService {
  constructor(
    private readonly requestBodyService: RequestBodyService,
    private readonly savedSearchService: SavedSearches,
    private readonly companyService: CompanyService,
    private readonly contactService: ContactsService,
    private readonly searchService: SearchService,
    private readonly router: Router,
    private readonly commonUtilService: CommonUtilService,
  ) { }

  onRecentSavedSerch(savedSearchData): void {
    this.savedSearchService.currentSearchId = savedSearchData.id;
    this.savedSearchService.currentSearchName = savedSearchData.searchName;
    this.searchService.universalCount = null;
    this.router.navigate(['results/search']);
    this.requestBodyService.changeCompanyBodyData(undefined);
    this.companyService.companyLoadedFlag.next(true);
    this.requestBodyService.changeContactBodyData(undefined);
    this.contactService.contactLoadedFlag.next(true);
    this.commonUtilService.getQuerySaveSearch(savedSearchData.id, savedSearchData.type.toLowerCase());
  }

  onReportingDashboardSearch(searchData: UniversalSearchModelType): void {
    this.commonUtilService.onReportingDashboardSearch(searchData);
  }
}
